(() => {
  let startX = 0;
  let startY = 0;
  let moved = false;

  document.addEventListener(
    'pointerdown',
    (e) => {
      const img = e.target.closest('.product-media-modal__content img');
      if (!img) return;

      startX = e.clientX;
      startY = e.clientY;
      moved = false;
    },
    true
  );

  document.addEventListener(
    'pointermove',
    (e) => {
      const img = e.target.closest('.product-media-modal__content img');
      if (!img) return;

      if (
        Math.abs(e.clientX - startX) > 10 ||
        Math.abs(e.clientY - startY) > 10
      ) {
        moved = true;
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      const img = e.target.closest('.product-media-modal__content img');
      if (!img || moved) return;

      const modal = img.closest('product-modal');
      if (modal?.hasAttribute('open')) {
        modal.hide();
      }
    },
    true
  );
})();